import { xssSafeHighlighter } from './highlighter.js';

function removeChildren(el) {
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }
}

function renderHighlight(el, text, keyword) {
    if (!text || !keyword || typeof text !== 'string') {
        // eslint-disable-next-line no-param-reassign
        el.textContent = text ?? '';
        return;
    }

    const fragments = xssSafeHighlighter.highlightAsXssSafeArr(text, keyword);
    const frag = document.createDocumentFragment();

    // eslint-disable-next-line no-restricted-syntax
    for (const { value, className } of fragments) {
        const node = document.createTextNode(value);
        if (className) {
            const span = document.createElement('span');
            span.classList.add(className);
            span.appendChild(node);
            frag.appendChild(span);
        } else {
            frag.appendChild(node);
        }
    }

    el.appendChild(frag);
}

function resolve(value) {
    return typeof value === 'function' ? value() : value?.value ?? value;
}

export default {
    mounted(el, binding) {
        const raw = binding.value || {};
        const text = resolve(raw.text);
        const keyword = resolve(raw.keyword);
        removeChildren(el);
        renderHighlight(el, text, keyword);
    },
    updated(el, binding) {
        const raw = binding.value || {};
        const text = resolve(raw.text);
        const keyword = resolve(raw.keyword);
        removeChildren(el);
        renderHighlight(el, text, keyword);
    },
};
